import React, { useState, useRef } from "react";
import { uploadData } from "@aws-amplify/storage";  // Updated import
import { ReactMediaRecorder } from "react-media-recorder";
import logo from "./assets/images/Amoofy_Logo.png";
//import capturingLogo from "./assets/images/capturing_logo.png";

const AudioRecorder = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const [isRecording, setIsRecording] = useState(false);
  const audioRef = useRef(null);

  const uploadAudio = async (blobUrl) => {
    setUploading(true);
    try {
      const response = await fetch(blobUrl);
      const blob = await response.blob();
      const fileName = `audio-${Date.now()}.mp3`;

      // Use uploadData instead of Storage.put
      const result = await uploadData({
        key: fileName,
        data: blob,
        options: {
          contentType: "audio/mpeg",
        }
      }).result;

      console.log('Upload success:', result);
      alert("Audio uploaded successfully!");
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("Upload failed.");
    }
    setUploading(false);
  };

  const requestMicrophoneAccess = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      return true;
    } catch (err) {
      console.error("Microphone access error:", err);
      setError("Could not access microphone: " + err.message);
      return false;
    }
  };

  const generateWaveBars = () => {
    return Array.from({ length: 30 }, (_, i) => (
      <div
        key={i}
        style={{
          width: '3px',
          backgroundColor: '#4CAF50',
          marginRight: '2px',
          borderRadius: '2px',
          animation: `waveform ${0.5 + Math.random() * 0.5}s ease-in-out infinite alternate`,
          animationDelay: `${i * 0.05}s`
        }}
      />
    ));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        height: "100vh",
        paddingTop: "40px",
        backgroundColor: 'transparent', // Set the entire background to transparent
        position: 'relative',
      }}
    >
      <style>
        {`
          @keyframes waveform {
            0% {
              height: 5px;
            }
            100% {
              height: 40px;
            }
          }

          /* Set background color on the body, html, and root */
          html, body, #root {
            background-color: transparent !important; /* Make body background transparent */
            margin: 0;
            height: 100%;
          }

          /* Position the logo at the top left corner fixed */
          .logo {
            position: fixed;
            top: 20px;
            left: 20px;
            width: 150px;
            z-index: 10;  /* Make sure the logo stays on top of other elements */
          }
        `}
      </style>

      <img src={logo} alt="Amoofy Logo" className="logo" />

      <h1> </h1>
     {/* <img src={capturingLogo} alt="Capturing Logo" style={{ width: "150px", marginBottom: "20px" }} /> */}
      
      <div
        style={{
          background: "rgba(255, 255, 255, 0.8)",  // Transparent background for recorder box
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          width: "fit-content",
          minWidth: "300px"
        }}
      >
        <ReactMediaRecorder
          audio
          mediaRecorderOptions={{
            mimeType: 'audio/mp4'
          }}
          onStart={() => {
            setIsRecording(true);
            setError(null);
            console.log("Recording started");
          }}
          onStop={(blobUrl, blob) => {
            setIsRecording(false);
            console.log("Recording stopped", { blobUrl, blob });
            if (audioRef.current) {
              audioRef.current.load();
            }
          }}
          onError={(err) => {
            console.error("Recording Error:", err);
            setError(err.message);
            setIsRecording(false);
          }}
          render={({ status, startRecording, stopRecording, mediaBlobUrl, clearBlobUrl }) => (
            <div>
              <h3>Audio Recorder</h3>
              <p>Status: {status}</p>
              {error && <p style={{ color: 'red' }}>Error: {error}</p>}
              
              {isRecording && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '60px',
                  marginBottom: '20px',
                  backgroundColor: 'transparent', // Transparent background for wave bars
                  borderRadius: '8px',
                  padding: '10px'
                }}>
                  {generateWaveBars()}
                </div>
              )}
              
              <div style={{ marginBottom: '20px' }}>
                <button 
                  onClick={async () => {
                    if (await requestMicrophoneAccess()) {
                      startRecording();
                    }
                  }}
                  disabled={isRecording}
                  style={{
                    marginRight: '10px',
                    padding: '8px 16px',
                    backgroundColor: isRecording ? '#ccc' : '#007bff',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: isRecording ? 'not-allowed' : 'pointer'
                  }}
                >
                  Start Recording
                </button>
                
                <button 
                  onClick={stopRecording} 
                  disabled={!isRecording}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: !isRecording ? '#ccc' : '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: !isRecording ? 'not-allowed' : 'pointer'
                  }}
                >
                  Stop Recording
                </button>
              </div>
              
              {mediaBlobUrl && (
                <div>
                  <p>Audio Preview:</p>
                  <audio 
                    ref={audioRef}
                    controls 
                    style={{ marginBottom: '20px', width: '100%' }}
                    onError={(e) => {
                      console.error("Audio playback error:", e);
                      setError("Error playing audio: " + e.message);
                    }}
                  >
                    <source src={mediaBlobUrl} type="audio/mp4" />
                    Your browser does not support the audio element.
                  </audio>
                  <div>
                    <button 
                      onClick={() => uploadAudio(mediaBlobUrl)} 
                      disabled={uploading}
                      style={{
                        marginRight: '10px',
                        padding: '8px 16px',
                        backgroundColor: uploading ? '#ccc' : '#28a745',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: uploading ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {uploading ? "Uploading..." : "Save Recording"}
                    </button>
                    <button 
                      onClick={() => {
                        clearBlobUrl();
                        setError(null);
                      }}
                      style={{
                        padding: '8px 16px',
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                    >
                      Clear Recording
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        />
      </div>
      
    </div>
  );
};

export default AudioRecorder;
